package games.polyclub.website.frontend.store.layout.userarea

import games.polyclub.frontend.lib.messagerenderer.Viewer
import games.polyclub.frontend.lib.messagerenderer.m
import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.message.BuildString
import games.polyclub.message.div
import games.polyclub.message.unaryMinus
import games.polyclub.service.player.id.api.OnlineMojangPlayerId
import games.polyclub.website.frontend.store.StoreBff
import games.polyclub.website.frontend.store.components.AsyncImg
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import react.Props
import react.router.dom.Link
import react.router.useLocation

val UserAreaMenuComponent = SFC<Props> { _ ->
    val authCtx = useAuth()
    val auth = authCtx.auth!!
    val profile = auth.profile
    val location = useLocation()

    Card("card-primary card-outline") {
        bodyClasses = "box-profile"
        div("text-center") {
            AsyncImg("profile-user-img img-fluid img-circle") {
                alt = -"Imagem ${"da"/profile} ${"jogadora"/profile}" - BuildString(Viewer)
                srcLoader = {
                    StoreBff.avatarUrl(profile.playerId ?: OnlineMojangPlayerId.MHF_Alex)
                }
            }
        }
        h3("profile-username text-center") {
            +profile.currentName.name
        }
        p("text-muted text-center") {
            m(-"${"Jogadora"/profile}")
        }
        h6("lead mt-4") {
            +"Suas Compras"
        }
        ul("nav nav-pills flex-column") {
            /*li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.HOME.path
                    LoggedSitemap.HOME.icon?.apply { renderIcon() }
                    +" Início"
                }
            }*/
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.CART.path
                    LoggedSitemap.CART.icon?.apply { renderIcon() }
                    +" Carrinho"
                }
            }
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.INVENTORY.path
                    LoggedSitemap.INVENTORY.icon?.apply { renderIcon() }
                    +" Inventário"
                }
            }
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.ORDERS.path
                    LoggedSitemap.ORDERS.icon?.apply { renderIcon("px-1") }
                    +" Pedidos"
                }
            }
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.MANAGE_PAYMENT_PROFILE.path
                    LoggedSitemap.MANAGE_PAYMENT_PROFILE.icon?.apply { renderIcon() }
                    +" Dados de Cobrança"
                }
            }
        }
        h6("lead mt-4") {
            +"Seu Perfil"
        }
        ul("nav nav-pills flex-column") {
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.CHANGE_PASSWORD.path
                    LoggedSitemap.CHANGE_PASSWORD.icon?.apply { renderIcon() }
                    +" Alterar Senha"
                }
            }
            li("nav-item") {
                Link("nav-link") {
                    to = LoggedSitemap.CHANGE_PRONOUN.path
                    LoggedSitemap.CHANGE_PRONOUN.icon?.apply { renderIcon() }
                    +" Alterar Meus Pronomes"
                }
            }
        }
    }
}
